import styled from 'styled-components'
import {
  flexDirection,
  FlexDirectionProps,
  maxWidth,
  MaxWidthProps,
  padding,
  PaddingProps,
  WidthProps,
} from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({ shouldForwardProp })<
  FlexDirectionProps & WidthProps & PaddingProps & MaxWidthProps
>`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.9')}px;
  width: 100dvw;
  max-height: 90dvh;

  ${flexDirection}
  ${padding}
  ${maxWidth}
`
